__turbopack_context__.v({
  "className": "rubik_7c165172-module__T0hw-q__className",
  "variable": "rubik_7c165172-module__T0hw-q__variable",
});
